import { IconButton, Stack, Tooltip } from "@mui/material";
import React from "react";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import CropLandscapeIcon from "@mui/icons-material/CropLandscape";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import { LANDSCAPE, PORTRAIT, SQUARE } from "store/chat";

export default function ImageRatioSelector({ ratio, setRatio }) {

  const handleSelectRatio = (ratio) => {
    setRatio(ratio);
  };

  return (
    <Stack direction="row">
      <Tooltip title="portrait" placement="top">
        <IconButton
          color={ratio === PORTRAIT ? "secondary" : "default"}
          onClick={() => handleSelectRatio(PORTRAIT)}
        >
          <CropPortraitIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="square" placement="top">
        <IconButton
          color={ratio === SQUARE ? "secondary" : "default"}
          onClick={() => handleSelectRatio(SQUARE)}
        >
          <CropSquareIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="landscape" placement="top">
        <IconButton
          color={ratio === LANDSCAPE ? "secondary" : "default"}
          onClick={() => handleSelectRatio(LANDSCAPE)}
        >
          <CropLandscapeIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
